import { formatToCompanyTimezone, formatToUtc, getDateTimeFromSelectedDate, getYearFromCompanyDate } from "../lib/functions";
import dayjs from "dayjs";
import Big from "big.js";

export const createPurchaseReturnPayload = (state) => {
  const {
    itemCart,
    supplierInfo,
    footerValues,
    conversion_rate,
    conversion_currency,
    entryDate,
    dueDate,
    voucherNumber,
    exp_id,
    selectedPurchaseReturnAcc,
    selectedDiscountAcc,
    selectedTaxAcc,
    tag_field_id,
    selectedInvoice,
    purId,
    otherServiceTrans,
    updatedServices,
    isTatmeen,
    parentSsccCode
  } = state;


  let finalEntryDate = entryDate;
  if (!dayjs(entryDate).isSame(dayjs(), "day")) {
    finalEntryDate = getDateTimeFromSelectedDate(entryDate); // Merge date + current time in TZ
  } else {
    finalEntryDate = entryDate; // Use now in TZ
  }

  console.log(itemCart, "itemCart123");

  let dateUTC = formatToUtc(finalEntryDate);
  let companydate = formatToCompanyTimezone(dateUTC);
  const vchYear = getYearFromCompanyDate(companydate);

  const {
    subtotal,
    total_discount,
    total_tax,
    grandTotal,
    paidAmount,
    dueAmount,
    description,
    discountPct,
    discount_acc_id,
    tax_acc_id,
    total_tax_per,
    total_discount_per,
  } = footerValues;


  const totalTax = itemCart.reduce((sum, curr) => {
    const itemTax = Big(curr.tax_per || 0)
      .div(100)
      .times(curr.item_return_rate || 0)
      .times(curr.return_qty || 0);
    return sum.plus(itemTax);
  }, Big(0));

  const totalDiscount = itemCart?.reduce(
    (sum, item) =>
      sum.plus(
        Big(item.item_discount || 0)
          .div(item.pur_qty || 1)
          .times(item.return_qty || 0)),
    Big(0)
  );

  const totalmergedServicesMap = {};

  const allUpdatedServices = Object.values(updatedServices || {}).flat();

  // itemCart.forEach((item) => {
  if (Array.isArray(allUpdatedServices)) {
    allUpdatedServices.forEach((service) => {
      const key = `${service.to_acc_id}_${service.service_name}`;
      const amount = Big(service.updated_service_total || 0);

      if (!totalmergedServicesMap[key]) {
        totalmergedServicesMap[key] = {
          to_acc_id: service.to_acc_id,
          service_name: service.service_name,
          total_service_amount: Big(0),
        };
      }

      totalmergedServicesMap[key].total_service_amount =
        totalmergedServicesMap[key].total_service_amount.plus(amount);
    });
  }
  const totalPayServiceCart = Object.values(totalmergedServicesMap).map(
    (service) => ({
      ...service,
      total_service_amount: service.total_service_amount.toString(),
    })
  );

  return {
    pur_r_id: exp_id || 0,
    // orderId: state.selectedInvoice?.pur_id || 0, // ✅ linked purchase invoice ID
    orderId: 0, // ✅ linked purchase invoice ID
    vchdate: vchYear,
    itemCart: itemCart.map((it) => ({
      pur_d_id: it.pur_d_id || null, // original purchase line this return line belongs to
      available_qty: it.available_qty,
      warehouse_id: it.warehouse_id || 0,
      item_id: it.item_id,
      item_name: it.product || "",
      display_text: `${it.product || ""} - `,
      is_serial: it.is_serial || "no",

      pur_qty: it.pur_qty || 0, // purchased qty
      pur_r_qty: it.return_qty || 0, // ✅ return qty
      item_qty: 0, // old UI always sends 0
      item_rate: it.rate,
      pur_r_rate: it.rate,
      item_return_rate: Big(it.item_return_rate || 0).toString(), // ✅ or keep same as rate if no logic
      stock_avg_rate: it.stock_avg_rate,

      discount_acc_id: it.discount_acc_id || 0,
      discount_acc_name: it.discount_acc_name || "",
      item_discount: it.item_discount || 0,
      return_discount: 0,
      item_discount_per: String(it.discount || 0),

      tax_acc_id: it.tax_acc_id || 0,
      tax_acc_name: it.tax_acc_name || "",
      // item_tax: ((Number(it.tax_per) / 100) * (Number(it.rate) || 0)).toFixed(2) || 0,
      item_tax_per: it.tax_per || 0,
      item_tax: it.item_tax,
      item_total: Big(it.return_qty || 0)
        .times(it.item_return_rate || 0)
        .toString(),
      per_symbol: it.per_symbol,

      qty_display: it.return_qty
        ? `${it.return_qty} ${it.unit_symbol || ""}`
        : "",
      unit_symbol: it.unit_symbol || "",
      unit_name: it.unit_name || "",
      base_unit_name: it.base_unit_name || null,
      conversion: it.conversion || 1,
      per_conversion: it.per_conversion || 1,
      per_unit_id: it.per_unit_id || 0,
      per_unit_symbol: it.per_unit_symbol || "",
      units: it.units || [],
      child_sscc_code: it.child_sscc_code || "",
      is_tatmeen_required: it.is_tatmeen_required ? 1 : 0,
      // serials: it.serials || [],
      serials:

        it.serial_mode === "batch"

          ?

          (

            it.availableSerials?.length

              ?

              [
                it.availableSerials[0]
              ]
              :
              []
          )
          :
          (
            it.selectedSerials || []
          ),
      serial_mode:
        it.serial_mode || "unit",
      retail_qty: 0,
      selected_batch_id: it.selected_batch_id,
      updatedServiceAllocations: [],
      otherServiceTransactions: [],
    })),

    supplier: {
      acc_id: supplierInfo?.acc_id,
      acc_name: supplierInfo?.acc_name,
      institution_name: supplierInfo?.institution_name,
      contact_no: supplierInfo?.contact_no,
      address: supplierInfo?.address,
    },

    masterData: {
      pur_r_voucher_no: voucherNumber,
      purchase_return_acc_id: selectedPurchaseReturnAcc?.acc_id || 0,
      pur_r_id: exp_id || state.pur_r_id || null,
      pur_id: purId,
      selected_invoice_no: typeof state.selectedInvoice === "object"
        ? state.selectedInvoice.pur_voucher_no : state.selectedInvoice,
      is_serial: "no",
      is_cal_type: state.taxMode === "on_item" ? "individual" : "on_total",
      apply_discount_to_avg_price: "no", // ✅ old UI always sends
      created_date: formatToUtc(finalEntryDate),
      is_tatmeen: isTatmeen ? 1 : 0,
      parent_sscc_code: parentSsccCode || '',
      ...(dueDate ? { due_date: formatToUtc(dueDate) } : {}),
      narration: description || "",
      sub_total: Big(subtotal || 0).toString(),
      total_discount_per: discountPct || 0,
      total_discount: totalDiscount.toString(),
      total_tax_per: total_tax_per || 0,
      total_tax: (totalTax).toString(),
      total_amount: Big(grandTotal || 0).toString(),
      paid_amount: Big(paidAmount || 0).toString(),
      discount_acc_id: selectedDiscountAcc?.acc_id || "",
      tax_acc_id: selectedTaxAcc?.acc_id || "",
      conversion_rate: conversion_rate || 0,
      conversion_currency: conversion_currency || null,
      ...(tag_field_id && tag_field_id.length > 0
        ? {
          tag_field_id: tag_field_id,
        }
        : {}),
    },

    payCart: (state.footerValues?.payCart || []).map((p, idx) => ({
      key: p?.key || idx + 1,
      to_acc_id: p?.to_acc_id || p?.from_acc_id || 0,
      to_acc_name: p?.to_acc_name || p?.from_acc_name || "",
      acc_type_id: p?.acc_type_id || "",
      tran_amount: Big(p?.tran_amount || 0).toString(),
      date: p.date || null,
      cheque_number: p?.cheque_number || null,
      expected_bank_acc_id: p?.expected_bank_acc_id || null,
    })),


    payServiceCart: totalPayServiceCart, // always empty
  };
};
